import React from 'react'

export const Button = ({ id, text, btnClass, onClickEve }) => {
  return (
    <button 
    onClick = {onClickEve}
    id = {id}
    className={btnClass}>
    {!text ? "Click" : text}
    </button>
  )
}
